<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
        :show="showRefreshItem"
        @onRefresh="fetchInitialData"
    ></refresh-item>

  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import StageCommentItem from "../layout/StageCommentItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import EzUtils from "../../utils/EzUtils";
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import LoanTasksUtility from "../../utils/LoanTasksUtility";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import DataSource from "../../data/DataSource";
import RefreshItem from "../layout/RefreshItem";
import { Constants } from "@/components/Constants";
import AssociatedEntityDataHolder from "@/data/model/AssociatedEntityDataHolder";


export default {
  name: "AssociatedEntitiesLoanStageProvider",
  components: {
    ErrorAlertItem,
    Loading,
    ToolBar,
    StageCommentItem,
    RefreshItem,
  },

  props : {
    associatedEntityTypes: {
      type: Array,
      required: true,
    },

    currentTaskName: {
      type: String,
      required: true
    },

    toolbarTitle: {
      type: String,
      required: true
    },

    associatedEntityHeading: {
      type: String,
      required: true
    }
  },

  data: () => ({
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,

    applicantType: null
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    fetchInitialDataExternal() {
      this.fetchInitialData();
    },

    fetchInitialData() {
      this.showRefreshItem = false;

      this.loading = true;
      DataSource.getClient(LoanScopeDataHolder.getClientId())
      .then(clientRes => {
        if (clientRes.errorOccurred) {
          this.showRefreshItem = true;
          this.showError(clientRes.data);
        } else {
          const clientDetails = clientRes.data;
          if (clientDetails && clientDetails.legalForm && clientDetails.legalForm.value) {
            const legalForm = clientDetails.legalForm.value;
            if (EzUtils.areEqualString(Constants.LEGAL_FORM_PERSON, legalForm, true)) {
              this.applicantType = Constants.APPLICANT_TYPE_INDIVIDUAL;
            } else if (EzUtils.areEqualString(Constants.LEGAL_FORM_ENTITY, legalForm, true)) {
              this.applicantType = Constants.APPLICANT_TYPE_ORGANIZATION;
            }
          }
          LoanTasksUtility.getLoanStageConfigData(
              LoanScopeDataHolder.getLoanId(),
              this.currentTaskName
          )
          .then(stageConfigDataRes => {
            this.loading = false;
            if (stageConfigDataRes.errorOccurred) {
              this.showRefreshItem = true;
              this.showError(stageConfigDataRes.data);
            } else {
              AssociatedEntityDataHolder.setAssociatedEntityDetails(
                  LoanScopeDataHolder.getLoanId(),
                  LoanScopeDataHolder.getLoanAmount(),
                  this.applicantType,
                  true,
                  this.associatedEntityTypes,
                  stageConfigDataRes.data,
                  this.associatedEntityHeading,
                  this.toolbarTitle
              );

              ActivityNavigator.navigateTo(Activities.ASSOCIATED_ENTITY_HOME);
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>
